import React, { Component } from "react";
import { connect } from 'react-redux';
import { View, FlatList } from 'react-native';
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Header from "../../../components/Header";
import { ListHeader, ListContainer } from "../../../components";
import ConversationGroup from "../../../components/List/ConversationGroup";
import { groupConversation, updateChatState } from "../../../action";
import { colors, global } from "../../../const";
import { localStorage } from "../../../functions/AsyncStorage";
import styles from "../../../styles";
import { IconButton } from "../../../components/form/Button";
import localize from "../../../localize";

class ConversationGroups extends Component {

    async componentWillMount() {
        let conversation = await localStorage(2, 'groupConversation');
        if (conversation) this.props.updateChatState({ groupConversation: conversation });
        this.props.groupConversation();
    }

    render() {
        const { groupConversation } = this.props.chat;
        const HeaderButton = () => (
            <IconButton
                onPress={() => this.props.history.push("chat/new-conversation")}
            >
                <Icon
                    icon={faPlus}
                    style={{ position: "static", fontSize: 18 }}
                    color={colors.white}
                />
            </IconButton>
        )

        return (
            <View style={styles.container}>
                <Header title={localize.conversations} right={<HeaderButton />} />
                <View style={{ height: this.props.height - 130 }}>
                    <FlatList
                        data={groupConversation}
                        keyExtractor={(item) => item.target}
                        ListHeaderComponent={() => <ListHeader title={localize.my_conversations} />}
                        renderItem={({ item }) => <ConversationGroup data={item} />}
                    />
                    {
                        groupConversation.length <= 0 ?
                            <View style={{ position: 'absolute', height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                                <View style={{ maxWidth: '70%', flex: 1 }}>
                                    <ListContainer color={colors.lightGray} />
                                    <View style={{ marginVertical: 5 }} />
                                    <ListContainer color={colors.ultralight} />
                                </View>
                            </View> : null
                    }
                </View>
            </View>
        );
    }
}

const mapStateToProps = ({ setting, chat }) => {
    return {
        height: setting.height,
        chat: chat
    }
}
const mapDispatch = (dispatch) => {
    return {
        groupConversation: () => dispatch(groupConversation()),
        updateChatState: id => dispatch(updateChatState(id))
    }
}
export default connect(mapStateToProps, mapDispatch)(ConversationGroups);